import { render, staticRenderFns } from "./step_datos_titular.vue?vue&type=template&id=56a5ccfc"
import script from "./step_datos_titular.vue?vue&type=script&lang=js"
export * from "./step_datos_titular.vue?vue&type=script&lang=js"
import style0 from "./step_datos_titular.vue?vue&type=style&index=0&id=56a5ccfc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports